import template from './tabs.html';
import controller from './tabs.controller';
import './tabs.styl';

let TabsComponent = () => {
  return {
    template,
    controller,
    controllerAs: 'tabs',
    restrict: 'E',
    scope: {},
    bindToController: {
      home: '='
    },
    transclude: true
  };
};

export default TabsComponent;



// WEBPACK FOOTER //
// ./src/components/tabs/tabs.component.js